import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerSemanticWordTranslations } from "./i18n";
import {
  applyVerdict,
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
} from "./progress";
import { emptySolution, type SemanticWordSolution } from "./solution";
import type { SemanticWordDefinition, SemanticWordProgress, SemanticWordSubmission } from "./types";

registerSemanticWordTranslations(i18n);

/**
 * No `localFeedback`: the vectors never leave the server. `applyVerdict` is what makes the
 * server's grading of each guess part of the autosaved history (ADR 0041).
 */
export const semanticWordModule: PuzzleTypeModule<
  SemanticWordDefinition,
  SemanticWordSubmission,
  SemanticWordProgress,
  SemanticWordSolution
> = {
  key: "semantic_word",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  applyVerdict,
};
